// extracted by mini-css-extract-plugin
export default {"tooltip":"CopyToClipboardButton-module__tooltip--Dq1IB"};